document.addEventListener('DOMContentLoaded', () => {
  initGridObserver();
});

function initGridObserver() {
  const gridContainer = document.getElementById('ProductGridContainer');
  if (!gridContainer) return;

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        shouldUpdate = true;
        break;
      }
    }

    if (shouldUpdate && window.updateGlymedButtonStates) {
      setTimeout(() => window.updateGlymedButtonStates(false), 50);
    }
  });

  observer.observe(gridContainer, { childList: true, subtree: true });
}
